import React, { FC, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';

import Accordion from '../index';
import Container from '../../../layout/Container';
import { useAccordionProtected } from '../../../uses/useAccordionProtected';

import { IAccordionProtected } from './interfaces';

import './styles.scss';

const { REACT_APP_GOOGLE_CAPTCHA }: any = process.env;

const AccordionProtected: FC<IAccordionProtected> = ({
  componentId,
  lang,
  pageApiUrl,
  value: { listitems },
}) => {
  const { t }: any = useTranslation();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [ challengeVisible, setChallengeVisible ] = useState(false);
  const {
    error,
    items,
    loading,
    locked,
    verifyCaptcha,
  } = useAccordionProtected({
    componentId,
    initialItems: listitems,
    pageApiUrl,
  });
  const captchaUnavailable = !REACT_APP_GOOGLE_CAPTCHA;
  const accordionItems = items.map((item) => ({
    ...item,
    body: item.body || '',
  }));

  const onCaptchaChange = async (token: string | null) => {
    if (!token) return;

    const verified = await verifyCaptcha(token);

    if (!verified) recaptchaRef.current?.reset();
  };

  if (!locked) {
    return <Accordion value={{ listitems: accordionItems }} />;
  }

  return (
    <div className="accordion-protected">
      <Container type={2}>
        <div className="accordion-protected--captcha">
          <div className="accordion-protected--captcha--message">
            <p>
              {challengeVisible
                ? t('accordion_protected.challenge')
                : t('accordion_protected.prompt')}
            </p>

            {loading &&
              <p aria-live="polite">
                {t('accordion_protected.loading')}
              </p>}
          </div>

          <div className="accordion-protected--captcha--control">
            {!captchaUnavailable && (challengeVisible
              ? <ReCAPTCHA
                  hl={lang}
                  ref={recaptchaRef}
                  sitekey={REACT_APP_GOOGLE_CAPTCHA}
                  onChange={onCaptchaChange}
                />
              : <button
                  className="accordion-protected--captcha--action"
                  disabled={loading}
                  onClick={() => setChallengeVisible(true)}
                  type="button">
                  {t('accordion_protected.action')}
                </button>)}
          </div>
        </div>

        {(error || captchaUnavailable) &&
          <p className="accordion-protected--error" role="alert">
            {t('accordion_protected.error')}
          </p>}
      </Container>

      <fieldset className="accordion-protected--locked" disabled>
        <Accordion value={{ listitems: accordionItems }} />
      </fieldset>
    </div>
  );
};

export default AccordionProtected;
